// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'
import axios from 'axios' //引入axios
Vue.prototype.$http = axios
import 'amfe-flexible';
Vue.config.productionTip = false
import 'vant/lib/index.css';
import { Tab, Tabs ,Divider,Col, Row ,Button,Image as VanImage,List,PullRefresh,Search ,Swipe,SwipeItem,Overlay } from 'vant';
Vue.use(Tab).use(Tabs).use(Divider).use(Col).use(Row).use(Button).use(VanImage).use(List).use(PullRefresh).use(Search).use(Swipe).use(SwipeItem).use(Overlay);

Vue.filter('snippet', function (value) {
  return value.slice(0, 4)
})
// eslint-disable no-new
new Vue({
  el: '#app',
  router,
  template: '<App/>',
  components: { App }
})



// WEBPACK FOOTER //
// ./src/main.js